
import {
  REQUEST_FEEDBACK_SHOW_SUMMARY_WINDOW,
  REQUEST_FEEDBACK_HIDE_SUMMARY_WINDOW,
  REQUEST_FEEDBACK_SHOW_OBJECT,
  REQUEST_FEEDBACK_LOAD_SURVEYS,
} from './actions';

const ROOT = 'requestFeedbackManager';

const initialState = {
  object: {

  },
  isAccount: false,
  showSummaryWindow: false,
  showRequestWindow: false,
  requests: [],
  surveys: {

  }, // indexed by object id
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_FEEDBACK_SHOW_OBJECT: {
      const { object, isAccount } = action;
      return {
        ...state,
        object,
        isAccount,
      };
    }
    case REQUEST_FEEDBACK_SHOW_SUMMARY_WINDOW: {
      return {
        ...state,
        showSummaryWindow: true,
      };
    }
    case REQUEST_FEEDBACK_HIDE_SUMMARY_WINDOW: {
      return {
        ...state,
        showSummaryWindow: false,
      };
    }
    case REQUEST_FEEDBACK_LOAD_SURVEYS: {
      const {
        id, items, loading, loaded, error,
      } = action;
      return {
        ...state,
        surveys: {
          ...state.surveys,
          [id]: {
            items,
            loading,
            loaded,
            error,
          },
        },
      };
    }
    default:
      return state;
  }
};


export const getObject = state => state[ROOT].object;
export const getShowSummaryWindow = state => state[ROOT].showSummaryWindow;
export const getShowRequestWindow = state => state[ROOT].showRequestWindow;
export const getIsAccount = state => state[ROOT].isAccount;

export const getSurveyLoading = (state, id) => {
  const { surveys } = state[ROOT];
  return surveys[id] ? surveys[id].loading : null;
};
export const getSurveyLoaded = (state, id) => {
  const { surveys } = state[ROOT];
  return surveys[id] ? surveys[id].loaded : null;
};
export const getSurveyItems = (state, id) => {
  const { surveys } = state[ROOT];
  return surveys[id] ? surveys[id].items : [];
};

// Export Reducer
export default Reducer;
